// ── Lenis smooth-scroll setup ──
// One Lenis instance, RAF-driven. Returns the instance for any consumer that
// needs scroll progress / velocity.

import Lenis from 'lenis';

export interface ScrollState {
  scroll: number;        // pixels from top
  progress: number;      // 0..1 across whole document
  velocity: number;      // pixels per frame (signed)
  direction: 1 | -1 | 0;
}

const _state: ScrollState = { scroll: 0, progress: 0, velocity: 0, direction: 0 };

export function getScrollState(): ScrollState {
  return _state;
}

export function setupLenis(): Lenis {
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 2,
  });

  lenis.on('scroll', (e: { scroll: number; velocity: number; direction: number; progress: number }) => {
    _state.scroll = e.scroll;
    _state.progress = e.progress;
    _state.velocity = e.velocity;
    _state.direction = e.direction === 0 ? 0 : e.direction > 0 ? 1 : -1;
  });

  return lenis;
}
